import { render } from "./OrderDetails.vue?vue&type=template&id=7e188866&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=7e188866&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e188866"

export default script